import Select from 'antd/es/select';
import React, { useState } from 'react';
import { SelectOption } from '..';
import { SelectOptions } from '../../../model/CommonModel';
import styles from './customFilters.module.scss';

export type Item = {
	key: string;
	value: string;
	label: string;
};

type Props = {
	prefixId: string;
	label: string;
	options: Item[];
	onSelectionChange: (value: string[]) => void;
};

const CustomFilters: React.FC<Props> = ({ prefixId, label, options, onSelectionChange }) => {
	//#region state management variables
	const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
	//#endregion

	const filteredOptions: Item[] = options.filter(
		o => selectedFilters === undefined || selectedFilters.length === 0 || selectedFilters.findIndex(x => x === o.value) === -1
	);

	const buildItem = (labeledValue: Item): SelectOptions<string> => {
		return {
			id: `filterOption-${labeledValue.key}`,
			key: labeledValue.key,
			value: labeledValue.value,
			label: labeledValue.label,
		};
	};

	const mappedOptions: SelectOption = filteredOptions.map((filter: Item) => buildItem(filter));

	return (
		<div className={styles.filterContainer}>
			<div className={styles.filterContent}>
				<label htmlFor={`${prefixId}CustomFilter`}>{<strong>{label}</strong>}:</label>
				<Select
					id={`${prefixId}CustomFilter`}
					mode='multiple'
					placeholder={label}
					value={selectedFilters?.map(x => {
						const item: Item = options.find(o => x.toString() === o.label.toString() || x.toString() === o.value.toString());
						return buildItem(item);
					})}
					options={mappedOptions}
					optionFilterProp='label'
					className={styles.filterSelect}
					onChange={(values: any[]) => {
						const actualValues: string[] = values.map<string>((value: string) => {
							const item: Item = options.find(option => value === option.label || value === option.value);
							return item?.value;
						});
						setSelectedFilters(actualValues);
						onSelectionChange(actualValues);
					}}
				/>
			</div>
		</div>
	);
};

export { CustomFilters };
